export const ANALYSIS_TYPE = {
    SUMMARY: 'summary',
    CLASSIFICATION: 'classification'
}

export const INTENT_RULES_OBJECT = {
    PEOPLE: 'people',
    COMPANY: 'company',
};

export const INTENT_RULES_STORE = {
    MULTIPLE: 'multiple-values',
    SINGLE: 'one-value',
};

export const INTENT_PROPERTIES_STORE = {
    MULTIPLE: 'multiple-tag',
    SINGLE: 'single-tag',
    TEXT: 'text-tag',
};

export const INTENT_RULES_EXISTING = {
    BLOCK: 'block',
    OVERRIDE: 'override',
    APPEND: 'append',
};

export const OBJECT_ANALYZE = [
    { value: INTENT_RULES_OBJECT.PEOPLE, label: 'People' },
    { value: INTENT_RULES_OBJECT.COMPANY, label: 'Companies' }
];

export const STORE_VALUES = [
    { value: INTENT_RULES_STORE.MULTIPLE, label: 'Multiple values' },
    { value: INTENT_RULES_STORE.SINGLE, label: 'One value' }
];

export const STORE_PROPERTIES_VALUES = [
    { value: INTENT_PROPERTIES_STORE.MULTIPLE, label: 'Multiple Tag' },
    { value: INTENT_PROPERTIES_STORE.SINGLE, label: 'Single Tag' },
    { value: INTENT_PROPERTIES_STORE.TEXT, label: 'Text' },
];

export const EXISTING_VALUES = [
    { value: INTENT_RULES_EXISTING.BLOCK, label: 'Block the analysis' },
    { value: INTENT_RULES_EXISTING.OVERRIDE, label: 'Override the existing value' },
    { value: INTENT_RULES_EXISTING.APPEND, label: 'Append the new value' }
];

export const INTENT_RULES_ROLLING_DATE_RANGE_OPTIONS = [
    { value: 'previous_week_sun_sat', label: 'Previous Week (Sun - Sat)' },
    { value: 'previous_week_mon_sun', label: 'Previous Week (Mon - Sun)' },
    { value: 'previous_week_sat_sun', label: 'Previous Week (Sat - Sun)' },
    { value: 'previous_week_fri_sun', label: 'Previous Week (Fri - Sun)' },
    { value: 'previous_month', label: 'Previous Month' },
    { value: 'month_to_date_yesterday', label: 'Month to Date (yesterday)' },
    { value: 'year_to_date_yesterday', label: 'Year to Date (yesterday)' },
    { value: 'quarter_to_date', label: 'Quarter to Date (yesterday)' },
    { value: 'previous_x_days', label: 'Previous X Days' },
    { value: 'previous_x_weeks', label: 'Previous X Weeks' },
    { value: 'lifetime_metrics', label: 'Lifetime metrics' },
];

export const INTENT_RULES_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    DRAFT: 'draft',
};

export const INTENT_RULES_STATUS_NUMBER_TO_TEXT = {
    [INTENT_RULES_STATUS.ACTIVE]: 'Active',
    [INTENT_RULES_STATUS.INACTIVE]: 'Inactive',
    [INTENT_RULES_STATUS.DRAFT]: 'Draft',
};

export const LLM_MODEL_NAMES = {
    GROK_2: 'grok-2',
    GROK_3: 'grok-3',
    GEMMA2_9B_IT: 'gemma2-9b-it',
    LLAMA_4_SCOUT_17B: 'meta-llama/llama-4-scout-17b-16e-instruct',
    LLAMA_3_1_8B: 'llama-3.1-8b-instant',
    GPT_OSS_20B: 'openai/gpt-oss-20b',
    GPT_OSS_120B: 'openai/gpt-oss-120b',
};

export const LLM_MODEL_TYPE_DESCRIPTIONS = {
    [LLM_MODEL_NAMES.GROK_2]: {
        [ANALYSIS_TYPE.SUMMARY]: "1 credit typically gets you 25 summaries",
        [ANALYSIS_TYPE.CLASSIFICATION]: "",
    },
    [LLM_MODEL_NAMES.GROK_3]: {
        [ANALYSIS_TYPE.SUMMARY]: "1 credit typically gets you 35 summaries",
        [ANALYSIS_TYPE.CLASSIFICATION]: "",
    },
    [LLM_MODEL_NAMES.GEMMA2_9B_IT]: {
        [ANALYSIS_TYPE.SUMMARY]: "1 credit typically gets you 800 summaries",
        [ANALYSIS_TYPE.CLASSIFICATION]: "1 credit typically gets you 1,000 classifications",
    },
    [LLM_MODEL_NAMES.LLAMA_4_SCOUT_17B]: {
        [ANALYSIS_TYPE.SUMMARY]: "1 credit typically gets you 1,000 summaries",
        [ANALYSIS_TYPE.CLASSIFICATION]: "1 credit typically gets you 1,100 classifications",
    },
    [LLM_MODEL_NAMES.LLAMA_3_1_8B]: {
        [ANALYSIS_TYPE.SUMMARY]: "1 credit typically gets you 2,500 summaries",
        [ANALYSIS_TYPE.CLASSIFICATION]: "1 credit typically gets you 3,500 classifications",
    },
    [LLM_MODEL_NAMES.GPT_OSS_20B]: {
        [ANALYSIS_TYPE.SUMMARY]: "1 credit typically gets you 800 summarizations",
        [ANALYSIS_TYPE.CLASSIFICATION]: "1 credit typically gets you 1000 classifications",
    },
    [LLM_MODEL_NAMES.GPT_OSS_120B]: {
        [ANALYSIS_TYPE.SUMMARY]: "1 credit typically gets you 500 summarizations",
        [ANALYSIS_TYPE.CLASSIFICATION]: "1 credit typically gets you 700 classifications",
    },
};

export const CLASSIFICATION_SUPPORTED_MODELS = [
    LLM_MODEL_NAMES.GEMMA2_9B_IT,
    LLM_MODEL_NAMES.LLAMA_4_SCOUT_17B,
    LLM_MODEL_NAMES.LLAMA_3_1_8B
];

export const SUMMARY_SUPPORTED_MODELS = [
    LLM_MODEL_NAMES.GROK_2,
    LLM_MODEL_NAMES.GROK_3,
    LLM_MODEL_NAMES.GEMMA2_9B_IT,
    LLM_MODEL_NAMES.LLAMA_4_SCOUT_17B,
    LLM_MODEL_NAMES.LLAMA_3_1_8B
];

export const AI_INTENT_TYPES = {
    AI_INTENT_CLASSIFICATION: ANALYSIS_TYPE.CLASSIFICATION,
    AI_INTENT_SUMMARY: ANALYSIS_TYPE.SUMMARY,
    AI_INSIGHT: 'ai_insight',
};

export const AI_INTENT_TYPES_TEXT = [
    { label: 'AI Intent - Classification', value: AI_INTENT_TYPES.AI_INTENT_CLASSIFICATION },
    { label: 'AI Intent - Summary', value: AI_INTENT_TYPES.AI_INTENT_SUMMARY },
    { label: 'AI Insight', value: AI_INTENT_TYPES.AI_INSIGHT },
]

export const ROUNDUP_INTENT = 0.05;

export const MAPPING_INTENT_OBJECT_ID = {
    [INTENT_RULES_OBJECT.PEOPLE]: 'personId',
    [INTENT_RULES_OBJECT.COMPANY]: 'companyId',
};

export const AI_INTENT_TRIGGER_TYPE = {
    SERVER_SIDE_TRIGGER: 'server_side_trigger',
    MANUAL_PREVIEW: 'manual_preview',
    MANUAL_RUN: 'manual_run',
    RERUN_INTENT: 'rerun_intent',
};